import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { ClassificationOverview } from '../model/classification-overview';
import { ClassificationConfiguration } from '../model/classification-configuration';
import { ClassificationSet } from 'model/classification-set';

@Injectable()
export class ClassificationService {
    constructor(private api: ApiService) {

    }
    
    getOverviewData() : Promise<ClassificationOverview> {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth<ClassificationOverview>(this.api.endpoints.classifications + '/GetOverviewData')
                .then(data => resolve(data), error => reject(error));
        });
    }

    getClassifiedData(configurationId: any, request: any) : Promise<ClassificationSet> {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth<ClassificationSet>(this.api.endpoints.classifications + '/GetClassifiedData?configurationId=' + configurationId, request)
                .then(data => resolve(data), error => reject(error));
        });
    }

    getClassifications(configurationId: any, request: any) : Promise<ClassificationSet> {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth<ClassificationSet>(this.api.endpoints.classifications + '/GetClassifications?configurationId=' + configurationId, request)
                .then(data => resolve(data), error => reject(error));
        });
    }
    
    getConfigurations() : Promise<ClassificationConfiguration[]> {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth<ClassificationConfiguration[]>(this.api.endpoints.classifications + '/GetConfigurations')
                .then(data => resolve(data), error => reject(error));
        });
    }

    saveConfiguration(configuration: ClassificationConfiguration) : Promise<ClassificationConfiguration> {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth<ClassificationConfiguration>(this.api.endpoints.classifications + '/SaveConfigurations', configuration)
                .then(data => resolve(data), error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/classification.service.ts